<template>
  <wrs-v-number v-model="model" :label="valueItem.label" @input="emitInputEvent" @deletion-detected="deletionDetected"
                :format="format" :errors="validationErrors" :hint="hint1"
                stack-label outlined dense class="mr-4">
  </wrs-v-number>
</template>
<script>
  // WrsViNumeric.vue

  import WrsVuetifyNumber from '../WrsVuetifyNumber.vue'

  export default {
    components: {
      'wrs-v-number': WrsVuetifyNumber
    },
    props: {
      valueItem: {
        type: Object,
        default: function () {
          return {
            value: 0,
            minValue: 0,
            maxValue: 0,
            rangeError: "",
            label: "",
            isRequired: false,
            requiredError: "",
            error: "",
            hasError: false
          };
        },
      },
      format: {
        type: String,
        default: "decimal"
      },
    },
    computed: {
      model: {
        get() {
          return this.valueItem.value;
        },
        set(value) {
          this.valueItem.value = value;
          this.checkForErrors(this.valueItem);
        }
      },
      validationErrors() {
        const errors = [];
        this.checkForErrors(this.valueItem);

        if (this.valueItem.hasError) errors.push(this.valueItem.error);
        return errors;
      },
      hint1: {
        get() {
          let vi = this.valueItem;
          let viHint = this.valueItem.hint;
          if (viHint == "") return "";
          if (vi.rangeType == "MIN")
            return viHint.replace("#MINVALUE#", vi.minValue);
          else if (vi.rangeType == "MAX")
            return viHint.replace("#MAXVALUE#", vi.maxValue);
          else if (vi.rangeType == "MINMAX")
            return viHint.replace("#MINVALUE#", vi.minValue).replace("#MAXVALUE#", vi.maxValue);
          else
            return "";
        }
      },
    },
    watch: {
      model() {
        this.checkForErrors(this.valueItem);
      }
    },
    methods: {
      checkForErrors: (vi) => {
        if (vi.isRequired) {
          var hasRequiredError = false;

          if (vi.allowZero && vi.value == "") {
            vi.value = 0;
          }

          if (vi.value == null) { hasRequiredError = true; }

          if (!hasRequiredError) {
            if (vi.allowZero) {
              if (vi.value < 0) { hasRequiredError = true; }
            }
            else {
              if (vi.value <= 0) { hasRequiredError = true; }
            }
          }

          if (hasRequiredError) {
            vi.hasError = true;
            vi.error = vi.requiredError;
            return;
          }
        }

        if (vi.rangeType != "") {
          if (vi.rangeType == "MIN" && vi.value < vi.minValue) {
            vi.hasError = true;
            vi.error = vi.rangeError.replace("#MINVALUE#", vi.minValue);
            return;
          }
          else if (vi.rangeType == "MAX" && vi.value > vi.maxValue) {
            vi.hasError = true;
            vi.error = vi.rangeError.replace("#MAXVALUE#", vi.maxValue);
            return;
          }
          else if (vi.rangeType == "MINMAX" && (vi.value < vi.minValue || vi.value > vi.maxValue)) {
            vi.hasError = true;
            vi.error = vi.rangeError.replace("#MINVALUE#", vi.minValue).replace("#MAXVALUE#", vi.maxValue);
            return;
          }
        }

        vi.hasError = false;
        vi.error = "";
      },
      emitInputEvent: function () {
        this.$emit('input');
      },
      deletionDetected: function () {
        if (this.valueItem.allowZero && this.valueItem.value === 0) {
          this.valueItem.value = null;
        }
      },
    }
  }
</script>

